// JS INDUSTRIES SHAPERBUDDY <-> SHOPIFY CONNECTOR
// PERISCOPE 2022
// 兆輝 2025-10-31

// Helper function to escape CSS selector special characters
function escapeCSSSelector(selector) {
  return selector.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
}

  // Runtime dimension signature helpers
  function parseFractionToken(tok){
    if(!tok) return NaN;
    const parts = tok.split('/');
    if(parts.length === 2){
      const a = parseFloat(parts[0]);
      const b = parseFloat(parts[1]);
      if(!isNaN(a) && !isNaN(b) && b) return a/b;
    }
    return NaN;
  }
  function normalizeInches(str){
    if(!str) return NaN;
    const s = (''+str).replace(/"/g,'').trim();
    const parts = s.split(' ');
    if(parts.length === 1){
      const n = parseFloat(parts[0]);
      return isNaN(n) ? NaN : n;
    }
    const base = parseFloat(parts[0]);
    const frac = parseFractionToken(parts[1]);
    if(!isNaN(base) && !isNaN(frac)) return base + frac;
    return isNaN(base) ? NaN : base;
  }
  function normalizeLengthFeet(str){
    if(!str) return NaN;
    const m = (''+str).match(/(\d+)'\s*(\d+)?/);
    if(!m) return NaN;
    const ft = parseInt(m[1],10);
    const inch = m[2] ? parseInt(m[2],10) : 0;
    return ft*12 + inch;
  }
  function normalizeVolume(str){
    if(!str) return NaN;
    const n = parseFloat((''+str).replace(/L/i,'').trim());
    return isNaN(n) ? NaN : n;
  }
  function normalizeDimensionNotation(dimString){
    // Normalize dimension notation by converting single quotes (') to double quotes (") for feet measurements
    // This ensures 5'6" and 5"6" are treated as the same dimension
    if(!dimString) return dimString;
    // Pattern: match digits followed by single or double quote, then digits and double quote
    // Convert single quote for feet to double quote: 5'6" -> 5"6"
    return (''+dimString).replace(/(\d+)['"](\d+)"/g, '$1"$2"');
  }
  function getConstToken(el){
    const c = el.className;
    if(c.includes(' HYFI ')) return 'HYFI';
    if(c.includes(' Carbotune ')) return 'Carbotune';
    if(c.includes(' EPS ')) return 'EPS';
    if(c.includes(' PE ')) return 'PE';
    if(c.includes(' PU ')) return 'PU';
    return '';
  }
  function getFinToken(el){
    const c = el.className;
    if(c.includes(' FCS ')) return 'FCS';
    if(/\bFUT\w*/i.test(c)) return 'Futures';
    return '';
  }
  function computeRuntimeSig(row){
    try{
      const dims = row.querySelectorAll('.dimms > div');
      if(dims.length < 4) return;
      const lenIn = normalizeLengthFeet(dims[0].textContent);
      const w = normalizeInches(dims[1].textContent);
      const t = normalizeInches(dims[2].textContent);
      const v = normalizeVolume(dims[3].textContent);
      const cons = getConstToken(row);
      const fin = getFinToken(row);
      if([lenIn,w,t,v].some(isNaN)) return;
      const sig = `${lenIn.toFixed(2)}|${w.toFixed(2)}|${t.toFixed(2)}|${v.toFixed(2)}|${cons}|${fin}`;
      row.setAttribute('data-sig-rt', sig);
    }catch(e){/* noop */}
  }

  // Store current filter state
  window.currentFilters = {
    construction: null,
    finSystem: null,
    colour: null
  };

  // Main rendering function: renders boards for specific construction/fin/colour
  function resolveConstructionKey(target){
    if(!window.boardData){ return target; }
    if(window.boardData[target]){ return target; }
    var normalized = (target || '').toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
    var keys = Object.keys(window.boardData);
    var match = keys.find(function(key){
      var normKey = key.toUpperCase().replace(/[^A-Z0-9]/g, '');
      return normKey === normalized;
    });
    if(!match){
      match = keys.find(function(key){
        var normKey = key.toUpperCase().replace(/[^A-Z0-9]/g, '');
        return normKey.indexOf(normalized) > -1 || normalized.indexOf(normKey) > -1;
      });
    }
    return match || target;
  }

  function renderBoards(construction, finSystem, colour){
    var resolvedConstruction = resolveConstructionKey(construction);
    if(resolvedConstruction !== construction){
      console.log('renderBoards construction remap:', construction, '→', resolvedConstruction);
    }
    construction = resolvedConstruction;
    console.log('renderBoards called:', { construction, finSystem, colour });
    
    // Update current filter state
    window.currentFilters.construction = construction;
    window.currentFilters.finSystem = finSystem;
    window.currentFilters.colour = colour;
    
    // Clear all board containers
    var containers = [
      document.querySelector(".boards:not(.tier1):not(.tier2):not(.tier3)"),
      document.querySelector(".boards.tier1"),
      document.querySelector(".boards.tier2"),
      document.querySelector(".boards.tier3")
    ];
    containers.forEach(function(container){
      if(container){
        // Remove all board data rows, but keep the heading row (first-child)
        var rows = container.querySelectorAll('.board-row.board');
        rows.forEach(function(row){ row.remove(); });
      }
    });
    
    // Get boards for this construction + fin combination
    if(!window.boardData || !window.boardData[construction] || !window.boardData[construction][finSystem]){
      console.warn('No board data for:', construction, finSystem);
      var mainContainer = document.querySelector(".boards:not(.tier1):not(.tier2):not(.tier3)");
      if(mainContainer){
        var span = document.createElement('span');
        span.innerHTML = "No boards available for this selection.";
        mainContainer.appendChild(span);
      }
      return;
    }
    
    var boardsToRender = window.boardData[construction][finSystem];
    
    console.log('renderBoards - boardsToRender before filtering:', boardsToRender.length, 'for', construction, finSystem);
    if(boardsToRender.length > 0 && construction === 'PU' && finSystem === 'FCS'){
      console.log('Sample PU FCS boards:', boardsToRender.slice(0, 3).map(function(b){
        return {length: b.length, var_id: b.var_id, tail_shape: b.tail_shape, construction: b.construction, fin_system: b.fin_system};
      }));
    }
    
    // Safety check: ensure all boards match current construction (defensive)
    boardsToRender = boardsToRender.filter(function(board){
      return (board.construction || '').toUpperCase() === (construction || '').toUpperCase();
    });
    
    // Filter by colour if specified
    if(colour){
      var colourUpper = colour.toUpperCase();
      boardsToRender = boardsToRender.filter(function(board){
        return !board.board_colour || board.board_colour.toUpperCase() === colourUpper;
      });
    }
    
    console.log('Rendering', boardsToRender.length, 'boards for', construction, finSystem);
    if(boardsToRender.length > 0 && construction === 'PU' && finSystem === 'FCS'){
      var instockCount = boardsToRender.filter(function(b){ return b.var_id; }).length;
      console.log('PU FCS boards - in-stock:', instockCount, 'made-to-order:', boardsToRender.length - instockCount);
    }
    
    // Debug: check if main container exists
    var testContainer = document.querySelector(".boards.tier1");
    console.log('Main .boards.tier1 container found:', !!testContainer, testContainer);
    
    // Track in-stock signatures to avoid rendering duplicate made-to-order
    var instockSignatures = new Set();
    boardsToRender.forEach(function(board){
      if(board.var_id){
        // Build signature for in-stock board
        var volKey = (parseFloat(board.volume_num || 0)).toFixed(2);
        var classId = 'n_'+board.length+board.width+board.thickness+volKey;
        classId = classId.replace(/\s/g, '').replace(/["']/g, "").replace(/\//g, "").replace(/\./g, "");
        var finTok = '';
        if(board.fin_system){
          var fs = (''+board.fin_system).toUpperCase();
          if(fs.indexOf('FCS') > -1){ finTok = 'FCS'; }
          else if(fs.indexOf('FUT') > -1){ finTok = 'Futures'; }
        }
        var sig = classId + '|' + board.construction + '|' + finTok;
        instockSignatures.add(sig);
      }
    });
    
    // Track rendered normalized dimensions to filter duplicates with inconsistent quote notation
    // Key: normalized dimension signature (using double quotes for feet)
    // Value: original dimension string that was rendered (to check if it uses double quotes)
    var renderedNormalizedDims = new Map();
    
    // Sort boards to prioritize double-quote notation (5"6") over single-quote notation (5'6")
    // This ensures that when duplicates exist, the double-quote version is processed first
    boardsToRender.sort(function(a, b){
      var aUsesDoubleQuotes = a.length && /^\d+"/.test(a.length);
      var bUsesDoubleQuotes = b.length && /^\d+"/.test(b.length);
      // If one uses double quotes and the other doesn't, prefer the double-quote one
      if(aUsesDoubleQuotes && !bUsesDoubleQuotes) return -1;
      if(!aUsesDoubleQuotes && bUsesDoubleQuotes) return 1;
      // Otherwise maintain original order
      return 0;
    });
    
    // Render each board
    boardsToRender.forEach(function(element){
      // Validate board has valid dimensions before rendering
      var hasValidLength = element.length && (''+element.length).match(/\d+'/);
      var hasValidWidth = element.width && (''+element.width).match(/\d+/);
      var hasValidThickness = element.thickness && (''+element.thickness).match(/\d+/);
      
      if(!hasValidLength || !hasValidWidth || !hasValidThickness){
        console.warn('Skipping board with invalid dimensions:', {
          length: element.length,
          width: element.width,
          thickness: element.thickness,
          title: element.name || element.identifier
        });
        return;
      }
      
      // Normalize length dimension for duplicate detection (convert single quotes to double quotes for feet)
      var normalizedLength = normalizeDimensionNotation(element.length);
      
      var volKey = (parseFloat(element.volume_num || 0)).toFixed(2);
      var classIdentifier = 'n_'+element.length+element.width+element.thickness+volKey;
      classIdentifier = classIdentifier.replace(/\s/g, '').replace(/["']/g, "").replace(/\//g, "").replace(/\./g, "");
      
      // Build normalized signature for duplicate detection (using normalized length)
      var normalizedClassId = 'n_'+normalizedLength+element.width+element.thickness+volKey;
      normalizedClassId = normalizedClassId.replace(/\s/g, '').replace(/["']/g, "").replace(/\//g, "").replace(/\./g, "");
      
      // Normalize fin token
      var finToken = '';
      if(element.fin_system){
        var fs = (''+element.fin_system).toUpperCase();
        if(fs.indexOf('FCS') > -1){ finToken = 'FCS'; }
        else if(fs.indexOf('FUT') > -1){ finToken = 'Futures'; }
      }
      
      var signature = classIdentifier + '|' + element.construction + '|' + finToken;
      
      // Build normalized signature for duplicate dimension detection
      var normalizedSignature = normalizedClassId + '|' + element.construction + '|' + finToken;
      
      // Check for duplicate dimensions with inconsistent quote notation
      // Prefer double-quote notation (5"6") over single-quote notation (5'6")
      if(renderedNormalizedDims.has(normalizedSignature)){
        var renderedLength = renderedNormalizedDims.get(normalizedSignature);
        // Check if feet measurement uses double quotes: pattern like 5"6" (digits followed by " at start)
        var currentUsesDoubleQuotes = /^\d+"/.test(element.length);
        var renderedUsesDoubleQuotes = /^\d+"/.test(renderedLength);
        
        // If current uses single quotes and rendered uses double quotes, skip current (prefer double quotes)
        if(!currentUsesDoubleQuotes && renderedUsesDoubleQuotes){
          console.log('Skipping duplicate dimension with single-quote notation (preferring double-quote):', element.length, 'vs', renderedLength);
          return;
        }
        // If current uses double quotes and rendered uses single quotes, prefer current (double quotes)
        // Since we sorted boards, this case should be rare, but if it happens we skip current
        // (the single-quote version was already rendered, we can't easily remove it)
        if(currentUsesDoubleQuotes && !renderedUsesDoubleQuotes){
          // This case should be rare due to sorting, but if it happens, skip to maintain consistency
          console.log('Skipping duplicate dimension (single-quote already rendered):', element.length, 'vs', renderedLength);
          return;
        }
        // If both use same notation, skip as true duplicate
        console.log('Skipping duplicate dimension:', element.length, 'vs', renderedLength);
        return;
      }
      
      // Mark this normalized signature as rendered (store original length for comparison)
      renderedNormalizedDims.set(normalizedSignature, element.length);
      
      // Skip made-to-order if matching in-stock exists
      if(!element.var_id && instockSignatures.has(signature)){
        console.log('Skipping made-to-order (in-stock exists):', element.length, signature);
        return;
      }
      
      var d = document.createElement('div');
      
      if(element.var_id){
        // In-stock board
        d.id = "b_" + element.var_id;
        d.className = 'board-row board instock p_'+element.board_id;
        d.innerHTML = `
          <div class="dimms">
            <div>`+element.length+`</div>
            <div>`+element.width+`</div>
            <div>`+element.thickness+`</div>
            <div class="volume">`+element.volume+`</div>
          </div>
          <div class="button-container">
            <button class="add board-button" onclick="addToCart(`+element.var_id+`)">ADD TO CART</button>
          </div>
        `;
        d.setAttribute('data-name', classIdentifier);
        d.setAttribute('data-sig', signature);
        d.setAttribute('data-fin', finToken);
      } else {
        // Made-to-order board
        var sbModelId = element.sb_model_id || '';
        var boardLength = element.length || '';
        var boardWidth = element.width || '';
        var boardThickness = element.thickness || '';
        
        d.className = 'board-row board sizegrid '+classIdentifier;
        d.setAttribute('data-sig', signature);
        d.setAttribute('data-fin', finToken);
        
        // Build HTML structure
        var dimmsDiv = document.createElement('div');
        dimmsDiv.className = 'dimms';
        dimmsDiv.innerHTML = '<div>'+boardLength+'</div>'+
                             '<div>'+boardWidth+'</div>'+
                             '<div>'+boardThickness+'</div>'+
                             '<div>'+element.volume+'</div>';
        
        var buttonContainer = document.createElement('div');
        buttonContainer.className = 'button-container';
        
        // Create button with proper event handler
        var button = document.createElement('button');
        button.className = 'board-button';
        button.textContent = 'MADE TO ORDER';
        button.addEventListener('click', function(e){
          e.preventDefault();
          if(typeof addToCustomOrder === 'function'){
            addToCustomOrder(sbModelId, boardLength, boardWidth, boardThickness);
          } else {
            console.error('addToCustomOrder function not found');
          }
        });
        
        buttonContainer.appendChild(button);
        d.appendChild(dimmsDiv);
        d.appendChild(buttonContainer);
      }
      
      // Add to appropriate tier container
      var targetContainer;
      if(element.tier == "TIER 2"){
        targetContainer = document.querySelector(".boards.tier2");
        if(targetContainer){ targetContainer.classList.remove('hide'); }
      } else if(element.tier == "TIER 3"){
        targetContainer = document.querySelector(".boards.tier3");
        if(targetContainer){ targetContainer.classList.remove('hide'); }
      } else {
        // Default: TIER 1 or no tier specified -> use .tier1 container
        targetContainer = document.querySelector(".boards.tier1");
        if(targetContainer){ targetContainer.classList.remove('hide'); }
      }
      
      if(targetContainer){
        targetContainer.appendChild(d);
        // Debug: log what button text is actually in the element
        var buttonText = d.querySelector('button') ? d.querySelector('button').textContent : 'NO BUTTON';
        console.log('Appended:', element.length, 'Button:', buttonText, 'var_id:', element.var_id);
      } else {
        console.warn('No container found for board:', element.tier, element);
      }
    });
    
    // Handle fader class for long lists
    var mainContainer = document.querySelector(".boards.tier1");
    if(mainContainer && boardsToRender.length > 12){
      mainContainer.classList.add('boards-fader');
    } else if(mainContainer){
      mainContainer.classList.remove('boards-fader');
    }
    
    // Remove loading spinner
    var spinner = document.querySelector(".loading-spinner");
    if(spinner){ spinner.classList.add('hide'); }
    
    // Remove loading class from containers
    document.querySelectorAll(".boards.loading").forEach(function(el){
      el.classList.remove("loading");
    });
  }

              // Add Board to cart
              function addToCart(varid){
                document.querySelector('#b_'+varid+' button').innerHTML = '<div class="lds-dual-ring"></div>';

                  let itemList = {
                    'items': [{
                      'id': varid,
                      'quantity': 1
                    }]
                  };

                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(itemList)

                }).then(response => {
                  document.querySelector('#b_'+varid+' button').innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';
                
                }).then(response => {
                  setTimeout(function(){ window.location.href = "/cart"; }, 800);
                
                }).catch((error) => {
                  console.error('Error:', error);
                });
              }

              // Add to Custom Order
              function addToCustomOrder(model, length, width, thickness){
                var tech = window.coTech || 47; // default to PU
                // Properly encode URL parameters to handle special characters
                var params = 'id_surfboardmodel=' + encodeURIComponent(model || '') +
                            '&co_length=' + encodeURIComponent(length || '') +
                            '&co_width=' + encodeURIComponent(width || '') +
                            '&co_thickness=' + encodeURIComponent(thickness || '') +
                            '&co_technology=' + encodeURIComponent(tech);
                window.location.href = '/pages/custom-order?' + params;
              }

              // Toggle Fin System Filter
              function toggleFins(filter=null, button = null){
                if(!filter || !window.currentFilters){ return; }
                // Normalize incoming label to canonical token
                const f = (filter || '').toString().toUpperCase();
                const finFilter = f.indexOf('FUT') > -1 ? 'Futures' : (f.indexOf('FCS') > -1 ? 'FCS' : '');
                if(!finFilter){ return; }
                
                // Check if this fin system exists for the current construction
                var currentConst = window.currentFilters.construction;
                if(!window.boardData || !window.boardData[currentConst] || !window.boardData[currentConst][finFilter]){
                  console.warn('Fin system "'+finFilter+'" not available for construction "'+currentConst+'"');
                  return; // Don't render if this combo doesn't exist
                }
                
                // Re-render with new fin filter
                renderBoards(currentConst, finFilter, window.currentFilters.colour);
              }

              // Toggle Colour Filter
              function toggleColour(filter=null, button = null){
                if(!window.currentFilters){ return; }
                // Re-render with new colour filter (null = show all colours)
                renderBoards(window.currentFilters.construction, window.currentFilters.finSystem, filter);
              }

              // Toggle Construction Filter
              function toggleConst(filter=null, button = null){
                if(!filter || !window.currentFilters){ return; }
                var rawFilter = (filter || '').toString().trim();
                var resolvedFilter = rawFilter;
                var upperFilter = rawFilter.toUpperCase();
                if(upperFilter.indexOf('CARBO') > -1){ resolvedFilter = 'Carbotune'; }
                else if(upperFilter.indexOf('HYFI') > -1){ resolvedFilter = 'HYFI'; }
                else if(upperFilter.indexOf('EPS') > -1){ resolvedFilter = 'EPS'; }
                else if(upperFilter.indexOf(' PE') > -1 || upperFilter === 'PE'){ resolvedFilter = 'PE'; }
                else if(upperFilter.indexOf(' PU') > -1 || upperFilter === 'PU'){ resolvedFilter = 'PU'; }
                else if(upperFilter.indexOf('SOFT') > -1){ resolvedFilter = 'SOFT'; }
                var availableConstructions = Object.keys(window.boardData || {});
                if(!availableConstructions.includes(resolvedFilter) && availableConstructions.length){
                  var normalizedTarget = upperFilter.replace(/[^A-Z0-9]/g, '');
                  var fuzzyMatch = availableConstructions.find(function(key){
                    return key.toUpperCase().replace(/[^A-Z0-9]/g, '') === normalizedTarget;
                  });
                  if(!fuzzyMatch){
                    fuzzyMatch = availableConstructions.find(function(key){
                      var normKey = key.toUpperCase();
                      return normKey.indexOf(upperFilter) > -1 || upperFilter.indexOf(normKey) > -1;
                    });
                  }
                  if(fuzzyMatch){ resolvedFilter = fuzzyMatch; }
                }
                console.log('toggleConst raw:', rawFilter, 'resolved:', resolvedFilter, 'available:', availableConstructions);
                filter = resolvedFilter;
                
                // Update coTech for addToCustomOrder function
                if(filter == 'PU'){ window.coTech = 47; }
                else if(filter == 'PE'){ window.coTech = 989; }
                else if(filter == 'EPS'){ window.coTech = 466; }
                else if(filter == 'HYFI'){ window.coTech = 1483; }
                else if(filter == 'Carbotune'){ window.coTech = 1481; }
                
                // Get first available fin for this construction, or keep current
                var newFin = window.currentFilters.finSystem;
                if(window.boardData && window.boardData[filter]){
                  var availableFins = Object.keys(window.boardData[filter]);
                  if(availableFins.length > 0 && !availableFins.includes(newFin)){
                    newFin = availableFins[0];
                  }
                }
                
                // Re-render with new construction filter
                renderBoards(filter, newFin, window.currentFilters.colour);
              }

            
              // Get Board Size Grid
              async function getBoards(model) {
                // Remove tail shape variations from model name before API call
                // Shaperbuddy doesn't include tail shape in model names
                // Common tail shapes: "Squash Tail", "Swallow Tail", "Round Tail", "Squashtail", etc.
                let cleanedModel = model;
                
                // Remove tail shape patterns (case-insensitive)
                const tailShapePatterns = [
                  /\s+Squash\s+Tail\s+/gi,
                  /\s+Swallow\s+Tail\s+/gi,
                  /\s+Round\s+Tail\s+/gi,
                  /\s+Squashtail\s+/gi,
                  /\s+Swallowtail\s+/gi,
                  /\s+Roundtail\s+/gi,
                  /\s+Squash\s+tail\s+/gi,
                  /\s+Swallow\s+tail\s+/gi,
                  /\s+Round\s+tail\s+/gi
                ];
                
                tailShapePatterns.forEach(pattern => {
                  cleanedModel = cleanedModel.replace(pattern, ' ');
                });
                
                // Clean up any double spaces and trim
                cleanedModel = cleanedModel.replace(/\s+/g, ' ').trim();
                
                // Only log if the model was actually changed
                if(cleanedModel !== model) {
                  console.log('[Shaperbuddy] Model name cleaned:', model, '->', cleanedModel);
                }

                const boardOptionsUrl = 'https://js-periscope-buddy.herokuapp.com/board-options.php?model=' + encodeURIComponent(cleanedModel);
                console.log('[JSI Board] Periscope getBoards →', boardOptionsUrl, { modelInput: model, cleanedModel: cleanedModel });
                
                const resp = await fetch(boardOptionsUrl, {
                    method: 'GET'
                });

                const data = await resp.json();
                
                if(data.boards != null) {
                  return data;
                }
              }


              // Get Board Size Grid
              async function getVolume(productId) {

                var myHeaders = new Headers();
                myHeaders.append("X-Shopify-Storefront-Access-Token", "86cfe01325b4ed8b7bdd820b9eb418c3");
                myHeaders.append("Content-Type", "application/graphql");
                myHeaders.append("Cookie", "_shopify_y=12ae615c-9c74-4887-934f-a2080efa0d99; _y=12ae615c-9c74-4887-934f-a2080efa0d99; localization=AU; secure_customer_sig=");

                var raw = "{\n  product(id: \"gid://shopify/Product/"+productId+"\") {\n      volume: metafield(namespace: \"surfboard\", key: \"volume\") {\n        value\n      }\n  }\n}";

                var requestOptions = {
                  method: 'POST',
                  headers: myHeaders,
                  body: raw,
                  redirect: 'follow'
                };

                const resp = await fetch("https://js-industries-aus.myshopify.com/api/2021-07/graphql.json", requestOptions);

                const data = await resp.json();

                
                return data;
              }